export default __webpack_public_path__ + "static/media/HaloFIcon.636cd695.png";